import React from 'react';

export default function PoliticaPrivacidade() {
  return (
    <div className="container py-5" style={{ maxWidth: '800px' }}>
      <div className="card shadow-sm border p-4 p-md-5 rounded-4 bg-white">
        <h1 className="fw-bold mb-4" style={{ color: 'var(--text-primary)', fontSize: '2rem', borderBottom: '2px solid var(--primary)', paddingBottom: '0.75rem' }}>
          Política de Privacidade
        </h1>
        <p className="text-secondary mb-4" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
          Última atualização: 14 de Julho de 2026
        </p>

        <section className="mb-4">
          <h2 className="h5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>1. Introdução</h2>
          <p className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            A <strong>IAC Buritama</strong> tem o compromisso de proteger a privacidade e a segurança dos dados pessoais de todos os usuários de nossa plataforma de inscrições. Esta Política de Privacidade explica como suas informações são coletadas, utilizadas e protegidas.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>2. Dados Coletados</h2>
          <p className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            Para realizar inscrições em nossos eventos, coletamos as seguintes informações fornecidas diretamente por você:
          </p>
          <ul className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6', paddingLeft: '1.5rem' }}>
            <li>Nome Completo;</li>
            <li>CPF (Cadastro de Pessoas Físicas);</li>
            <li>Endereço de E-mail;</li>
            <li>Número de WhatsApp/Telefone;</li>
            <li>Respostas aos campos personalizados definidos para cada evento específico.</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>3. Uso dos Dados</h2>
          <p className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            Os dados coletados são utilizados exclusivamente para:
          </p>
          <ul className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6', paddingLeft: '1.5rem' }}>
            <li>Processar e confirmar sua inscrição nos eventos selecionados;</li>
            <li>Enviar informações importantes sobre o evento (como atualizações de horários ou locais);</li>
            <li>Gerar o seu ticket/comprovante de entrada com QR Code;</li>
            <li>Cumprir obrigações fiscais e regulatórias do processamento de pagamentos.</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>4. Processamento de Pagamento Seguro</h2>
          <p className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            Toda transação financeira (via Pix ou Cartão de Crédito/Débito) é processada de forma segura diretamente através dos servidores do <strong>Mercado Pago</strong> utilizando a tecnologia de criptografia Secure Fields da própria bandeira.
          </p>
          <p className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            A <strong>IAC Buritama não armazena</strong> nem tem acesso aos dados sensíveis do seu cartão de crédito (como número do cartão, data de validade ou CVV). Nós recebemos apenas a resposta de confirmação de pagamento enviada pelo Mercado Pago para validar seu ingresso.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>5. Compartilhamento de Dados</h2>
          <p className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            Nós não vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros para fins de marketing. O compartilhamento ocorre estritamente com os processadores de pagamento (Mercado Pago) e sistemas de envio de e-mails para garantir a prestação dos serviços e envio de ingressos.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>6. Direitos do Usuário (LGPD)</h2>
          <p className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            Conforme a Lei Geral de Proteção de Dados (LGPD), você possui o direito de solicitar a qualquer momento:
          </p>
          <ul className="text-secondary" style={{ fontSize: '0.95rem', lineHeight: '1.6', paddingLeft: '1.5rem' }}>
            <li>Confirmação da existência de tratamento dos seus dados;</li>
            <li>Correção de dados incompletos, inexatos ou desatualizados;</li>
            <li>Exclusão dos seus dados de nosso banco de dados (exceto quando necessário para obrigações legais ou fiscais da instituição).</li>
          </ul>
        </section>

        <section className="mb-0">
          <h2 className="h5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>7. Contato</h2>
          <p className="text-secondary mb-0" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
            Se você tiver dúvidas sobre esta Política de Privacidade ou desejar exercer seus direitos de privacidade, entre em contato conosco através do e-mail: <a href="mailto:iacburitama@gmail.com" style={{ color: 'var(--primary)', textDecoration: 'none' }}>iacburitama@gmail.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
